import {createFileRoute} from '@tanstack/react-router'

import {WorkerTypesPage} from 'src/assets/worker-types/worker-types-page'

export const Route = createFileRoute('/_app/workers/types/')({
    component: WorkerTypesRoute,
})

function WorkerTypesRoute() {
    return <WorkerTypesPage />
}
